import { Enums } from '@bode-canada/core';
import PropertyTransaction from '@/components/features/sold-property/models/PropertyTransaction';

// @vue/component
const HistoryTabsMixin = {
  data() {
    return {
      transactionsDto: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userData;
    },
    latestSoldTransaction() {
      return this.transactions
        .find(({ status }) => (status === Enums.ListingStatusEnum.SOLD));
    },
    transactions() {
      return this.transactionsDto
        .map((transaction) => new PropertyTransaction(transaction, !this.user.isAuthenticated));
    },
    isAllTransactionsHidden() {
      return this.transactions.every(({ status }) => status === Enums.ListingStatusEnum.HIDDEN);
    },
    historyTabs() {
      return this.transactions.map((transaction) => ({
        id: transaction.listingId,
        title: `${transaction.status} ${transaction.formattedCloseDate}`,
        description: transaction.isSold ? transaction.formattedPrice : 'N/A',
      }));
    },
  },
};

export default HistoryTabsMixin;
